export default __webpack_public_path__ + "static/media/pokemonLogo.534ad5af.png";